import Head from "next/head";
import React from "react";
import { HeroCTA, HeroContentFull, HeroCtas, HeroSubtitle, HeroWrapper } from "../../components/pages/Hero";
import { GradientDivider } from "../../components/GradientDivider";
import { Button } from "../../components/Button";
import ParallaxHero from "../../components/ParallaxHero";
import Layout from "../../components/layouts/HomeLayout";
import { GetAllProductPages } from "../../components/helpers";

export default function LandingPage ({handleToast, user, busy, setMobileMenu, mobileMenuIsOpen, isTransparent, content}) {
    const getSection = (slug) => {
        return content.content.filter((section) => section.__typename === slug)[0];
    };
    const hero = getSection("ProductHeroRecord");

    return <>
        <Layout handleToast={handleToast} user={user} busy={busy} setMobileMenu={setMobileMenu} mobileMenuIsOpen={mobileMenuIsOpen} isTransparent={isTransparent}>
            <Head>
                <title>{content.title}</title>
                <meta name="description" content={content.description} />
                <meta property="og:description" content={content.description} />
                <meta property="og:title" content={content.title} />
                <meta name="og:image" content={`https://covalent-og.vercel.app/api/og?title=Alchemist%20Program`} />
                <link
                    rel="canonical"
                    href={`https://www.covalenthq.com/alchemist-program/`}
                    key="canonical"
                />
            </Head>
            <ParallaxHero imageUrl="https://www.datocms-assets.com/86369/1697820116-alchemists_background.jpg?dpr=0.5&fm=webp 1920w,https://www.datocms-assets.com/86369/1697820116-alchemists_background.jpg?dpr=0.75&fm=webp 2880w,https://www.datocms-assets.com/86369/1697820116-alchemists_background.jpg?fm=webp 3840w">
                <GradientDivider height={800}/>
                <HeroWrapper dark size="lg">
                    <HeroContentFull>
                        <h1 className="title">
                            {hero.title}
                        </h1>
                        <HeroSubtitle center={true}>
                            {hero.subtitle}
                        </HeroSubtitle>
                        <HeroCtas center={true}>
                            <HeroCTA><Button href={hero.ctaUrl}>{hero.ctaText}</Button></HeroCTA>
                        </HeroCtas>
                    </HeroContentFull>
                </HeroWrapper>
            </ParallaxHero>
            <style jsx>{`
            .title {
                letter-spacing: 20px;
                text-align: center;
                font-size: var(--font-size-jumbo);
                line-height: 1.05;
                font-weight: var(--font-weight-light);
            }
            @keyframes animate-in-title {
                0% {
                    opacity: 0;
                    transform: translateY(10%) scale(0.98);
                }
                100% {
                    opacity: 1;
                    transform: translateY(0%) scale(1);
                }
            }
            @keyframes animate-in-subtitle {
                0% {
                    opacity: 0;
                    transform: translateY(10%) scale(0.98);
                }
                100% {
                    opacity: 1;
                    transform: translateY(0%) scale(1);
                }
            }
            @keyframes animate-in-cta {
                0% {
                    opacity: 0;
                    transform: translateY(10%) scale(0.98);
                }
                100% {
                    opacity: 1;
                    transform: translateY(0%) scale(1);
                }
            }


    `}</style>
        </Layout>
    </>;
}

export async function getStaticProps() {
    const allPages = await GetAllProductPages();
    const content = allPages.filter((page) => page.slug === "alchemist-program")[0];
    content.meta = {
        title: content.title,
        description: content.description
    };
    return {
        props: {
            component: "LandingPage",
            content: content,
        },
    };
}
